<google-pay-button
  environment="PRODUCTION"
  [buttonType]="'long'"
  [buttonSizeMode]="'fill'"
  [paymentRequest]="googlePaymentRequest"
  (error)="onError($event)"
  (errorCallback)="consoleError($event)"
  [paymentAuthorizedCallback]="onPaymentDataAuthorized"
></google-pay-button>
